export type PlanType = 'duo' | 'family';
export const PLAN_DUO: PlanType = 'duo';
export const PLAN_FAMILY: PlanType = 'family';

export const guessPlanType = (urlPath: string): PlanType =>
  urlPath.includes('/family/') ? 'family' : 'duo';

export const guessPlanMaxCapacity = (planType: string): number =>
  planType === PLAN_FAMILY ? 6 : 2;
